import React from 'react';
import { Button, Typography } from '@mui/material';
import AccessDenied from '../../assets/images/access-denied.svg';
import { useNavigate } from 'react-router-dom';
import { getData } from 'utilities/common';
import { setData } from 'utilities/common';

export default function PageNotFound() {
  const navigate = useNavigate();
  let localUser = getData('login-user-info');
  if (localUser) {
    localUser = JSON.parse(localUser);
  }

 // Get user-permissions object from localStorage, fallback to empty object if missing
  let userPermissions = {};
  try {
    userPermissions =
      localUser?.permissions
      // userPermissions2
      || {};
  } catch (e) {
    userPermissions = {};
  }


  // Honor existing adminsMode selection
  const adminsModeData = getData('adminsMode');
  const selectedAdminMode = adminsModeData ? JSON.parse(adminsModeData) : null;

  let permissionsArray = [];
  if (selectedAdminMode === 'hemp') {
    permissionsArray = Array.isArray(userPermissions.hempPermissions) ? userPermissions.hempPermissions : [];
  } else if (selectedAdminMode === 'hyperwolf') {
    permissionsArray = Array.isArray(userPermissions.hwPermissions) ? userPermissions.hwPermissions : [];
  } else if (selectedAdminMode === 'stilo') {
    permissionsArray = Array.isArray(userPermissions.stiloPermissions) ? userPermissions.stiloPermissions : [];
  } else if (selectedAdminMode === 'hyperdrive') {
    permissionsArray = Array.isArray(userPermissions.hyperdrivePermissions) ? userPermissions.hyperdrivePermissions : [];
  }  else {
    // Fallback to first non-empty
    if (Array.isArray(userPermissions.hwPermissions) && userPermissions.hwPermissions.length > 0) {
      permissionsArray = userPermissions.hwPermissions;
    } else if (Array.isArray(userPermissions.hempPermissions) && userPermissions.hempPermissions.length > 0) {
      permissionsArray = userPermissions.hempPermissions;
    } else if (Array.isArray(userPermissions.stiloPermissions) && userPermissions.stiloPermissions.length > 0) {
      permissionsArray = userPermissions.stiloPermissions;
    }else if (Array.isArray(userPermissions.hyperdrivePermissions) && userPermissions.hyperdrivePermissions.length > 0) {
      permissionsArray = userPermissions.hyperdrivePermissions;
    }
  }

  // Determine first accessible route from permissions
  // Short, dynamic route selection based on permissions array:
  let screenToLoad = '/';
  if (Array.isArray(permissionsArray) && permissionsArray.length > 0) {
    // Find first permission with a non-empty redirectUrl
    const found = permissionsArray.find(
      p => p?.redirectUrl
    );
    if (found && found.redirectUrl) {
      screenToLoad = found.redirectUrl;
    }
  }

  return (
    <div className="access-denied-page">
      <div className="access-denied-inner">
        <img src={AccessDenied} alt="Access Denied" />
        <Typography variant='h1'>Access Denied</Typography>
        <Typography>You do not have permission to access this page. Please contact your administrator.</Typography>
        <Button onClick={() => { navigate(screenToLoad, { replace: true }); }} size="medium" variant="contained" color="primary">Back to home</Button>
      </div>
    </div>
  );
}
